
import React from 'react';
import ReactDraggable from 'react-draggable';
var Draggable = ReactDraggable;

interface DraggablePanelData {
    node: HTMLElement,
    x: number,
    y: number,
    deltaX: number,
    deltaY: number,
    lastX: number,
    lastY: number
}

interface DraggablePanelProps extends React.PropsWithChildren<{}> {
    containerClass?: string[];
    initialPosition?: { x: number, y: number };
    bounds?: { left: number, top: number, right: number, bottom: number };
    commandList?: any[];
    minDimensions?: { x: number, y: number };
    maxDimensions?: { x: number, y: number };
    defaultSize?: { x: number, y: number };
    onDrag?: (e: any, data: any) => void;
    onClick?: (e: React.MouseEvent) => void;
}

class DraggablePanel extends React.Component<DraggablePanelProps, any> {

    constructor(props: DraggablePanelProps) {
        super(props);
        
        this.state = { display: false };
    }

    private _containItems(arr: any[]) {
        return arr !== undefined &&
            arr !== null &&
            arr.length > 0;
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render(): any {
        var classNames = 'draggable-panel';
        if (this._containItems(this.props.containerClass)) {
            classNames += ' ' + this.props.containerClass.join(' ');
        }

        var cmdList: any[] = [];
        if (this._containItems(this.props.commandList)) {
            cmdList = this.props.commandList;
        }

        var initialPos = { x: 200, y: 200 };
        if (this.props.initialPosition) {
            initialPos = this.props.initialPosition;
        }

        var defaultHeight = 200;
        var defaultWidth = 200;

        var styles: React.CSSProperties = {
            width: defaultWidth + 'px',
            height: defaultHeight + 'px'
        };
        if (this.props.defaultSize) {
            styles.width = this.props.defaultSize.x + 'px';
            styles.height = this.props.defaultSize.y + 'px';

            defaultHeight = this.props.defaultSize.y;
            defaultWidth = this.props.defaultSize.x;
        }

        var bounds = {
            top: 0,
            left: 0,
            bottom: window.innerHeight,
            right: window.innerWidth
        };
        if (this.props.bounds) {
            bounds = this.props.bounds;
        }

        return (
            <Draggable handle='.window-cmd' defaultPosition={initialPos} bounds={bounds} onDrag={this.props.onDrag} onStart={this.props.onClick as any}>
                <div className={classNames} style={styles} onClick={this.props.onClick}>
                    <div className='window-cmd'>{cmdList.map(function (cmd) { return cmd }) }</div>
                    <div className='content-panel'>
                        { this.props.children }
                    </div>
                </div>
            </Draggable>);
    }
}

export default DraggablePanel;